import { api } from "../api";

/**
 * Open real phpMyAdmin in a new tab via SSO signon.
 * - WHM staff: pass { serverWide: true } for all server databases
 * - cPanel / account: pass { userId } (defaults to current session user)
 */
export async function openPhpMyAdmin(opts?: {
  userId?: string;
  databaseId?: string;
  serverWide?: boolean;
}): Promise<void> {
  const res = await api<{ url: string }>(
    "/api/v1/databases/pma-sso",
    {
      method: "POST",
      body: JSON.stringify({
        userId: opts?.userId,
        databaseId: opts?.databaseId,
        serverWide: Boolean(opts?.serverWide)
      })
    }
  );
  const path = res.url.startsWith("http")
    ? res.url
    : `${window.location.origin}${res.url}`;
  // Prefer same-tab if popup blocked; always keep token in URL
  const w = window.open(path, "_blank");
  if (!w || w.closed) {
    window.location.assign(path);
  }
}
